import styled from "styled-components";

interface HomeSectionWrapperProps {
  background?: string;
}

export const HomeSectionWrapper = styled.div<HomeSectionWrapperProps>`
  width: 100%;
  height: 100%;
  background: linear-gradient(
      to right,
      rgba(33, 34, 37, 0.95),
      rgba(33, 34, 37, 0.95)
    ),
    ${(props) =>
      props.background ? `url(${props.background})` : 'url("/images/bg.jpg")'};
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HomeInfo = styled.div`
  text-align: center;
  max-width: 80rem;
  margin: 5rem;
  margin-top: -15rem;

  & h1 {
    font-family: "Aclonica", sans-serif;
    font-size: 6rem;
    color: #3fca89;
    text-shadow: 0px 4px 3px rgba(0, 0, 0, 0.4), 0px 8px 13px rgba(0, 0, 0, 0.1),
      0px 18px 23px rgba(0, 0, 0, 0.1);
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: -1.5rem;
      left: 0;
      width: 5rem;
      height: 2px;
      background: #fff;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -0.5rem;
      right: 0;
      width: 5rem;
      height: 2px;
      background: #fff;
    }
  }

  & p {
    font-family: "Aladin", cursive;
    font-size: 2.5rem;
    margin-top: 2rem;
  }
`;
